import styled from "@emotion/styled";
import { PureComponent } from "react";
import { FieldRenderProps } from "react-final-form";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

const StyledNumberInput = styled.span`
  position: relative;
  display: inline-block;

  input {
    line-height: 42px;
    height: 42px;
    border-radius: 4px;
    border: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
    padding: 0 40px 0 10px;
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.primaryColor80
    };
    text-align: right;
    max-width: 100%;
    box-sizing: border-box;
  }

  .add,
  .remove {
    position: absolute;
    top: 0;
    right: 0;
    height: 50%;
    width: 30px;
    border-left: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
    cursor: pointer;
    &:after {
      position: absolute;
      top: calc(50% - 2.5px);
      left: calc(50% - 5px);
      content: "";
      border-style: solid;
      border-width: 0 5px 5px 5px;
      border-color: transparent transparent
        ${
          // FIXME: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
          (props: any) => props.theme.primaryColor80
        }
        transparent;
    }
  }

  .remove {
    top: auto;
    bottom: 0;
    border-top: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
    &:after {
      border-width: 5px 5px 0 5px;
      border-color: ${
          // FIXME: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
          (props: any) => props.theme.primaryColor80
        }
        transparent transparent transparent;
    }
  }
`;

interface IProps extends FieldRenderProps<string, HTMLSpanElement> {
  className?: string;
  max?: number;
  min?: number;
}

interface IState {
  value: number;
}

export class NumericInput extends PureComponent<IProps, IState> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  addValue = (val: any) => () => {
    this.props.input.onChange(this.calcValue(parseInt(this.props.input.value, 10) + val));
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  handleChange = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    const { input, min } = this.props;
    const inputVal = e.target.value.replace(/^0+/, "");
    const val = parseInt(inputVal, 10);

    if (inputVal === "") {
      input.onChange(min || 0);
      return;
    }
    // Don't allow any other characters than number
    if (String(val) !== inputVal) {
      input.onChange(input.value);
    } else {
      input.onChange(this.calcValue(val));
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  calcValue(val: number) {
    const { max, min } = this.props;

    if (max && val > max) {
      val = max; // eslint-disable-line
    }

    if (min && val < min) {
      val = min; // eslint-disable-line
    }

    return val;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    return (
      <StyledNumberInput className={this.props.className}>
        <input type="text" {...this.props.input} onChange={this.handleChange} />
        <span className="add" onClick={this.addValue(1)} />
        <span className="remove" onClick={this.addValue(-1)} />
      </StyledNumberInput>
    );
  }
}
